export default {
  mounted: (el, binding) => {
    if (binding && binding.value) {
      el.setAttribute('hz-tuto', binding.value)
    }
  },
}
